import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import TextBoxWithTooltip from '../../../../textBoxWithTooltip';

const useStyles = makeStyles(
  ({ palette: { primary }, spacing, breakpoints }) => ({
    root: {
      backgroundColor: primary.white,
      cursor: 'pointer',
      display: 'grid',
      alignItems: 'center',
      gridTemplateColumns:
        'minmax(50px, 50px) minmax(132px, 1.5fr) minmax(90px, 1fr) minmax(90px, 1fr) minmax(160px, 1fr) minmax(60px, 90px)',
      boxSizing: 'border-box',
      transition: 'background-color .3s ease',
      '&:hover': {
        backgroundColor: primary.bluish9,
      },
      '&:last-of-type': {
        borderBottom: 'none',
      },
    },
    item: {
      boxSizing: 'border-box',
      padding: spacing(3, 2),

      [breakpoints.up('xLg')]: {
        padding: spacing(3, 4),
      },
    },
    surveyTitleWrapper: {
      minWidth: 0,
    },
    link: {
      textDecoration: 'none',
    },
    actions: {
      boxSizing: 'border-box',
      cursor: 'default',
      padding: spacing(1, 1),

      [breakpoints.up('xLg')]: {
        padding: spacing(1, 3),
      },
    },
  })
);

const Review = ({ review, detailsUrl }) => {
  const classes = useStyles();
  const { type, title, startsOn, endsOn, status, actions } = review;

  const handleActionsClick = e => e.stopPropagation();

  return (
    <div className={classes.root}>
      <Link className={classes.link} to={detailsUrl}>
        <div className={classes.item}>{type}</div>
      </Link>
      <Link className={classes.link} to={detailsUrl}>
        <div className={classNames(classes.item, classes.surveyTitleWrapper)}>
          {title}
        </div>
      </Link>
      <Link className={classes.link} to={detailsUrl}>
        <TextBoxWithTooltip className={classes.item} text={startsOn || '-'} />
      </Link>
      <Link className={classes.link} to={detailsUrl}>
        <TextBoxWithTooltip className={classes.item} text={endsOn || '-'} />
      </Link>
      <Link className={classes.link} to={detailsUrl}>
        <div>{status}</div>
      </Link>
      <div className={classes.actions} onClick={handleActionsClick}>
        {actions}
      </div>
    </div>
  );
};

Review.propTypes = {
  review: PropTypes.object.isRequired,
  detailsUrl: PropTypes.string.isRequired,
};

export default Review;
